import {
  computeFragments,
  DAY_SECONDS,
  SCORE_PER_SURVIVAL_SECOND,
} from '../config/balance.js';
import type { GameState } from './types.js';

export function tickScoreSurvival(state: GameState, dt: number): void {
  if (state.gameOver) return;
  state.score += SCORE_PER_SURVIVAL_SECOND * dt;
}

export function fragmentsForRun(state: GameState): number {
  const weeks = state.weeksRewarded;
  return computeFragments(weeks, state.score);
}

export function dayFromSimTime(simTime: number): number {
  return Math.floor(simTime / DAY_SECONDS) + 1;
}

export function weekFromDay(day: number): number {
  return Math.floor((day - 1) / 7) + 1;
}
